import O1HD from "../../../engines/gameEngine";
import utilsView from "../../../engines/libs/utilsView";
import { FileKind } from "../../define/FileKind";

const {ccclass, property} = cc._decorator;

@ccclass
export default class outSizePage extends cc.Component {

    //点击我要白嫖
    onBtnComit(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        utilsView.openPopupLayerTwo(FileKind.PrefabFilePath.feedBackPage);
        this.closeThis();
    }

    closeThis(){
        this.node.destroy();
    }

}
